import { airportResponseType } from "src/Modules/Flights/constants";

const mapOption = (data: airportResponseType) => {
  const cityName = data.cityName != "" ? `${data.cityName},` : `${data.countryName},`;
  return {
    label: `${cityName} (${data.iataCode})`,
    value: data.iataCode,
    country: data.countryName,
    city: data.cityName,
    iataCode: data.iataCode,
    airport: data.name,
  };
};


type MappedOptionType = ReturnType<typeof mapOption>;

export { mapOption };
export type {MappedOptionType};
